var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.overlayClasses,attrs:{"id":"overlay"}},[_c('span',{attrs:{"id":"overlay-loading-text"}},[_vm._v("Now Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }